export const filesData = [
    {
      key: "1",
      id: "1",
      name: "Digimed",
      lastModified: "22 Apr 2024",
      size: "200 MB",
      ownedMember: "Janet",
      action: "Permanent Delete, Restore File",
      imgSrc: "assets/img/icons/folder.svg",
      ownedMemberImgSrc: "assets/img/students/student-01.jpg"
    },
    {
      key: "2",
      id: "2",
      name: "Estimation",
      lastModified: "23 Apr 2024",
      size: "100 MB",
      ownedMember: "Henriques",
      action: "Permanent Delete, Restore File",
      imgSrc: "assets/img/icons/xls.svg",
      ownedMemberImgSrc: "assets/img/profiles/avatar-01.jpg"
    },
    {
      key: "3",
      id: "3",
      name: "Intro.pdf",
      lastModified: "24 Apr 2024",
      size: "150 MB",
      ownedMember: "Nolan Harris",
      action: "Permanent Delete, Restore File",
      imgSrc: "assets/img/icons/pdf-02.svg",
      ownedMemberImgSrc: "assets/img/profiles/avatar-02.jpg"
    },
    {
      key: "4",
      id: "4",
      name: "Demoworrking.mp4",
      lastModified: "25 Apr 2024",
      size: "250 MB",
      ownedMember: "Sarah",
      action: "Permanent Delete, Restore File",
      imgSrc: "assets/img/icons/video.svg",
      ownedMemberImgSrc: "assets/img/profiles/avatar-03.jpg"
    },
    {
      key: "5",
      id: "5",
      name: "voice.mp3",
      lastModified: "26 Apr 2024",
      size: "180 MB",
      ownedMember: "William",
      action: "Permanent Delete, Restore File",
      imgSrc: "assets/img/icons/audio.svg",
      ownedMemberImgSrc: "assets/img/profiles/avatar-04.jpg"
    }
  ];
  
  